// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { Auth } from 'aws-amplify';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { isEmail } from '../../../lib/validation';
import TextBoxInput from '../../../components/TextBoxInput';
import BlockPopSubmit from './components/blockPopSubmit';
import PopUpInfo from './components/PopUpInfo';
import S from './styles';
import { useIntl } from 'react-intl';
import { BIFROST_URL } from '../../../configuration';
import { checkLoginMethod } from '../../../apis/member';

const ForgetPasswordForm = (): JSX.Element => {
  const history = useHistory();
  const [blockSubmit, setBlockSubmit] = useState(false);
  const [showResetCheck, setshowResetCheck] = useState(false);

  const gotoBirfrost = async () => {
    window.location.href = BIFROST_URL;
  }

  const checkLogin = async (email: string) => {
    const result = await checkLoginMethod(email);
    return result
  }

  const cognitoResetPassword = async (email: string) => {
    Auth.forgotPassword(email)
      .then(data => {
        console.log({ data });
        history.push(`/forgotPassword?sent=true&email=${email}`);
      })
      .catch(err => {
        console.log({ err });
      })
      .finally(() => {
        console.log('finally');
      })
  }
  return (
    <Formik
      initialValues={{
        email: ''
      }}
      validate={values => {
        const errors: { email?: string }= {};
        if (!values.email) {
          errors.email = 'J045'
        } else if (!isEmail(values.email)) {
          errors.email = 'J045'
        }

        return errors;
      }}
      onSubmit={ async ({ email }, { setSubmitting, resetForm }) => {
        console.log({ email });
        if (email.endsWith('ecloudvalley.com')) {
          // check user login method, true: need to use bifrost, false: use cognito login, can send email
          const loginMethod = await checkLogin(email);
          if (loginMethod.data) {
            setBlockSubmit(true);
          } else {
            setshowResetCheck(true);
          }
        } else {
          await cognitoResetPassword(email);
        }
        setSubmitting(false);
        resetForm({ values: { email: '' } });
      }}>
      {({
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        isSubmitting
      }) => {
        const intl = useIntl();
        const errorMessage = errors.email ? '*' + intl.formatMessage({ id: errors.email }) : undefined;

        return (
          <S.Container as={Form}>
            <S.TopWrapper>
              <TextBoxInput
                textBoxName= {intl.formatMessage({ id: 'J043' })}
                placeholder= {intl.formatMessage({ id: 'J043' })}
                name="email"
                value={values.email}
                error={errorMessage}
                touched={touched.email}
                onChange={handleChange}
                onBlur={handleBlur}
                autoComplete="new-password"
              />
            </S.TopWrapper>
            <S.BottomWrapper>
              <S.Button
                type="submit"
                disabled={isSubmitting || Object.keys(errors).length > 0}
              >{intl.formatMessage({ id: 'J044' })}</S.Button>
            </S.BottomWrapper>
            { blockSubmit ? <BlockPopSubmit setClickSubmit={setBlockSubmit} gotoBirfrost={gotoBirfrost}/> : null }
            { showResetCheck ? <PopUpInfo setClickSubmit={setshowResetCheck} cognitoResetPassword={cognitoResetPassword} email={values.email}/> : null }
          </S.Container>
        )
      }}
    </Formik>
  );
}

export { ForgetPasswordForm as default }
